module.exports = __webpack_public_path__ + "static/media/Converse-Donation-Hist.bf9a411d.png";